import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from './schedulePO.module.css';
import { Back, Upload } from '../../../Svg';
import { useNavigate } from 'react-router-dom';
import { getAllScheduleProductThunk, uploadschedulepoThunk } from '../../redux/ScheduleSlice';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import DeliveryAddressPopup from '../../../Dashboard/CustomerDash/Components/allEnquiresTab/SelectAddress';

const SchedulePO = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { scheduleData, refresh } = useSelector((state) => state.schedule);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [open, setOpen] = useState(false);

    // Fetch schedule data
    useEffect(() => {
        dispatch(getAllScheduleProductThunk());
    }, [refresh]);

    // Formik setup
    const formik = useFormik({
        initialValues: {
            products: [],
            purchaseOrderUri: '',
            period: '',
            scheduleDate: '',
            remarks: '',
        },
        validationSchema: Yup.object({
            purchaseOrderUri: Yup.string()
                .url('Please upload a valid file')
                .required('Purchase Order is required'),
            period: Yup.number()
                .positive('Period must be a positive number')
                .required('Period is required'),
            scheduleDate: Yup.date()
                .typeError('Invalid date format')
                .required('Schedule Date is required'),
            remarks: Yup.string().required('Remarks are required'),
        }),
        onSubmit: async (values) => {
            setOpen(true)
        },
    });



    const handleSaveSelection = async () => {
        const day = new Date(formik.values.scheduleDate).getDate();
        const formData = {
            ...formik.values,
            scheduleDate: day,
            shippingAddress: selectedAddress
        };

        const status = await dispatch(uploadschedulepoThunk(formData))

        if (status?.payload === 200) {
            navigate('/scheduleCart')
        }

    };

    // Handle File Upload
    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        try {
            if (file) {
                setLoading(true);
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });
                    formik.setFieldValue('purchaseOrderUri', data?.data?.url);
                }
            }
        } catch (err) {
            console.error(err);
            toast.error('Error uploading file');
        } finally {
            setLoading(false);
        }
    };

    // Populate product data
    useEffect(() => {
        if (scheduleData?.length) {
            const products = scheduleData.map((item) => ({
                productId: item.productId,
                quantity: item.quantity,
                totalQty: item.totalQty,
            }));
            formik.setFieldValue('products', products);
        }
    }, [scheduleData]);

    return (
        <>
            <div className={styles.imgBread}>
                <span>Schedule PO Form</span>
            </div>
            <div className={styles.formSection}>
                <div>
                    <button className={styles.compBtn} onClick={() => navigate(-1)}>
                        <Back />
                        Back to previous page
                    </button>
                </div>
                <div className={styles.bomTabsCol2}>
                    <p>
                        PO File Upload Steps:
                        <ol>
                            <li>Upload your PO.</li>
                            <li>Fill the required details and submit.</li>
                            <li>Purchase your parts by scheduling it.</li>
                        </ol>
                    </p>
                    <a href='' className={styles.download}>
                        Download our PO template
                    </a>
                </div>
                <form onSubmit={formik.handleSubmit} className={styles.card}>
                    <p className={styles.addCatLabel}>
                        Choose the file and sheet to upload. At minimum you will need to include part numbers and quantities for each.
                    </p>
                    <div className={styles.imageUpload}>
                        <h2 className={styles.addCatH2}>Upload PO</h2>
                        <label htmlFor="fileUpload">
                            {loading ?
                                <div className={styles.uploadBox}>
                                    please wait...
                                </div>
                                :
                                <>
                                    {formik.values.purchaseOrderUri ?
                                        <div className={styles.uploadBox}>
                                            {formik.values.purchaseOrderUri}
                                        </div>
                                        :
                                        <div className={styles.uploadBox} style={{ cursor: 'pointer' }}>
                                            <span className={styles.uploadIcon}>
                                                <Upload />
                                            </span>
                                            <p className={styles.addCatPara}>Choose the file and sheet to upload</p>
                                            <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                id="fileUpload"
                                                accept=".xlsx, .xls"
                                                onChange={handleFileUpload}
                                            />
                                            <div className={styles.addImgBtn} style={{width: "fit-content",margin: "auto"}}>
                                                Choose File
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </label>
                        {formik.errors.purchaseOrderUri && formik.touched.purchaseOrderUri && (
                            <div className={styles.errorText}>{formik.errors.purchaseOrderUri}</div>
                        )}
                        <p className={styles.addCatLabel}>We support .xls, .xlsx, and .csv files under 4MB</p>
                    </div>

                    <h2 className={styles.addCatH2} style={{ marginTop: '30px' }}>
                        Fill the below details
                    </h2>
                    <div className={styles.qrForminputs} >
                        <label className={styles.addCatLabel} >
                            Months Period
                            <input
                                type="number"
                                name="period"
                                placeholder="Enter period"
                                className={styles.addCatInput}
                                value={formik.values.period}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.period && formik.touched.period && (
                                <div className={styles.errorText}>{formik.errors.period}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel}>
                            Schedule Date
                            <input
                                type="date"
                                name="scheduleDate"
                                placeholder="Enter schedule date"
                                className={styles.addCatInput}
                                value={formik.values.scheduleDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.scheduleDate && formik.touched.scheduleDate && (
                                <div className={styles.errorText}>{formik.errors.scheduleDate}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel}>
                            Project Remarks
                            <input
                                type="text"
                                name="remarks"
                                placeholder="Enter remarks"
                                className={styles.addCatInput}
                                value={formik.values.remarks}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.remarks && formik.touched.remarks && (
                                <div className={styles.errorText}>{formik.errors.remarks}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.displayFlex}>
                        <button type="button" className={styles.cancelBtn} onClick={() => formik.resetForm()}>
                            Cancel
                        </button>
                        <button type="submit" className={styles.submitBtn} disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? "please wait..." : "Submit"}
                        </button>
                    </div>
                </form >
                <DeliveryAddressPopup
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                    setOpen={setOpen}
                    open={open}
                    handleSubmit={handleSaveSelection}
                />
            </div >
        </>
    );
};

export default SchedulePO;
